export const SWW = "Something went Wrong!";